import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import JisDialogForm from "../../components/formdialog";
import JisTabButton from "../../components/controls/jisTabButton";
import DeadlineBadge from "../../components/controls/deadlinebadge";
import * as Services from "../../services";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import { X } from "lucide-react";

function PostDeputySheriff() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert,holidays } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isLiti, setIsLitiation] = useState(null);
  const [openCheck, setOpenCheck] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [selectedWrits, setSelectedWrits] = useState({});
  const [assignTo, setAssignTo] = useState(null);
  const [sheriffs, setSheriffs] = useState([]);
  const [tab, setTab] = useState("pending");
  const [lgid, setLgId] = useState(0);
  const [lgs, setLgs] = useState([]);
  const openRef = useRef(openCheck);
  const [openOption, setOpenOption] = useState(false);
  const [clearStatus, setClearStatus] = useState("");
  const [isRework, setIsRework] = useState(false);

  useEffect(() => {
    //onLoad();
    onLoadSheriffByDivision();
  }, []);

  useEffect(() => {
    if (search != null) {
      if (pageIndex >= 0) {
        console.log(
          "loding from direct useEffect with pageIndex,pageSize,search",
        );
        console.log(`is search ${isSearch}`);
        onSearch(search);
      } else {
        setPageIndex(0);
      }
    }
    if (lgs.length == 0) {
      onGetLgs();
    }
  }, [pageIndex, pageSize, search, tab]);

  useEffect(() => {
    openRef.current = openCheck;
    if (!openCheck) return; // Only start when openCheck is true

    let stopNext = false; // this flag prevents new calls but lets current one finish

    const fetchSequentially = async () => {
      const writList = Object.values(selectedWrits);
      let updatedWrits = { ...selectedWrits };

      for (const writItem of writList) {
        if (!openRef.current) {
          stopNext = true;
          break;
        }

        const writId = writItem.id;

        try {
          const verified = await Services.onVerifyStayOfExecution(
            writItem.case?.caseId,
          );
          if (!openCheck) {
            // ✅ re-check state after current call completes
            stopNext = true;
            break;
          }

          if (verified != null) {
            updatedWrits[writId] = {
              ...updatedWrits[writId],
              verified,
            };

            setSelectedWrits({ ...updatedWrits });
          }
        } catch (err) {
          console.error(
            `Error fetching related cases for ${writItem.case?.caseId}:`,
            err,
          );
        }
      }
    };

    fetchSequentially();

    return () => {
      // cleanup just sets stopNext flag
      stopNext = true;
    };
  }, [openCheck]);

  const onCheck = (value, opt) => {
    let sel = selected;
    let updateSel = { ...selectedWrits };
    if (value) {
      sel.add(opt.id);
      updateSel[opt.id] = opt;
    } else {
      sel.delete(opt.id);
      delete updateSel[opt.id];
    }
    setSelected(new Set(sel));
    setSelectedWrits(updateSel);
    console.log(Object.keys(updateSel));
  };

  const onRemoveWrit = (opt) => {
    let sel = selected;
    let updateSel = { ...selectedWrits };

    sel.delete(opt.id);
    delete updateSel[opt.id];
    setSelected(new Set(sel));
    setSelectedWrits(updateSel);

    setAlert({
      open: true,
      title: "Remove Writ from the list",
      subtitle:
        "The Writ case removed from the selected. The dialog will close if that is the last item",
    });
    if (Object.values(updateSel).length == 0) {
      setOpenCheck(false);
    }
  };

  const onLoadSheriffByDivision = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/get-by-screen-access/execution-sherrif`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setSheriffs(data.pros);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/deputy-sheriff-post-judgement/${lgid}/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      setIsSearch(true);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onGetLgs = async () => {
    //for account registration
    try {
      //setLocs({...locs,lga:false});
      const resp = await fetch(`${Constants.apiUrl}/profile/lgs/15`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setLgs(data);
    } catch (error) {
      console.error(error);
    }
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    navigate(`/case-details/${fee.caseId}`);
    //navigate(`/case-details/${caseid}`)
    // setActive(fee);
    // setIndex(ind);
    // setOpenCase(true);
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
  };

  const onSave = async (e) => {
    e.preventDefault();
    console.log(option);
    if (option.manualVerify != true) {
      setErr(
        "Please check to confirm you have also checked manually that its not on Stay on Execution",
      );
      return;
    }

    if (assignTo == null) {
      setErr("Please selecte one of the listed Service Sherrif");
      return;
    }

    var unverifiy = Object.values(selectedWrits).filter((k) => !k.verified);
    if (unverifiy.length > 0) {
      setErr("Please remove the case that on Stay of Execution");
      return;
    }

    var writids = Array.from(selected);
    setErr("");
    //var judgeAs=isCmc==true?'CMC':'Trial';
    var approve = { ...option, writids, assignType: "ds", assignTo: assignTo }; //deputy

    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/post-assign-writ`, {
        method: "POST",
        body: JSON.stringify(approve),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenCheck(false);
        setSelected(new Set());
        setSelectedWrits({});
        setAlert({
          open: true,
          title: "Deputy Sheriff Assignment",
          subtitle: "Cases assigned successfully",
        });
        setPageIndex(-1); // this will auto load again
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onOptionChange = (e) => {
    setOption({ ...option, [e.target.name]: e.target.value });
  };

  const onSaveClear = async (e) => {
    e.preventDefault();

    if (active.verified == null) {
      setErr("Please Check that its not on Stay on Execution online");
      return;
    }
    if (active.verified == false) {
      setErr("Its confirmed it has Motion on it. You cant continue");
      return;
    }
    if (option.manualVerify != true) {
      setErr(
        "Please check to confirm you have also checked manually that its not on Stay on Execution",
      );
      return;
    }

    var approve = { ...option, writId: active.id, source: "ds" };
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/post-judgement-clear/${active.id}`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenOption(false);
        const ft = cases.filter((_, i) => i !== index);
        setCases(ft);
        if (isLiti == false) {
          setAlert({
            open: true,
            title: "Option",
            subtitle: "rejected successfully",
          });
        } else {
          setAlert({
            open: true,
            title: "Option",
            subtitle: "accepted successfully",
          });
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onClear = (cc, ind) => {
    //can load the option for filing type and display

    setActive(cc);
    setIndex(ind);
    setOpenOption(true);
    setOption({
      caseId: cc.case?.caseId,
      caseCategoryId: cc.case?.caseCategoryId,
      divisionId: cc.case?.divisionId,
    });
  };

  const onVerifyStay = async () => {
    var _active = active;
    setLoading(true);
    const verified = await Services.onVerifyStayOfExecution(
      active.case?.caseId,
    );
    console.log("verification result " + verified);
    setActive({ ...active, verified });
    setLoading(false);
  };

  const onChangeTab = (newTab) => {
    setTab(newTab);
    // Clear bulk assign state
    setSelected(new Set());
    setSelectedWrits({});
    setOpenCheck(false);
  };

  return (
    <div>
      {/* <CaseSearch onSearch={onSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader onSearch={onSearch} frequentData={frequentData} />

      <div style={{ textAlign: "right" }}>
        {Object.keys(selectedWrits).length > 0 && (
          <JisButton onClick={() => setOpenCheck(true)}>
            {" "}
            Bulk Asign ({Object.keys(selectedWrits).length})
          </JisButton>
        )}
      </div>

      <div style={{ marginBottom: 24 }} className="tab_body">
        <div className="tab_section">
          <JisTabButton
            isActive={tab == "pending"}
            title="Pending"
            isRoleBased={false}
            onClick={() => onChangeTab("pending")}
          />
          {/* <JisTabButton
            isActive={tab == "assigned"}
            title="Assigned"
            isRoleBased={false}
            onClick={() => setTab("assigned")}
          /> */}
          <JisTabButton
            isActive={tab == "warrants"}
            title="Warrants"
            isRoleBased={false}
            onClick={() => onChangeTab("warrants")}
          />
          <JisTabButton
            isActive={tab == "warrants-assigned"}
            title="Assigned Warrants"
            isRoleBased={false}
            onClick={() => onChangeTab("warrants-assigned")}
          />
        </div>
        <div className="tab_view"></div>
      </div>
      {cases?.length == 0 && <JisEmptyList />}
      {cases?.length > 0 && (
        <div className="table">
          <div class="section-cases">
            <span>Deputy Sherrif </span>
          </div>
          <div className="table-wrapper">
            <table class="case-table">
              <thead>
                <tr>
                  <th className="col-title">Suit Number</th>
                  <th className="col-title">Case Title</th>
                  <th className="col-medium">Filing Type</th>
                  <th className="col-medium">Classification</th>
                  <th className="col-medium">Date Initiated</th>
                  <th className="col-medium">Status Level</th>
                  <th>LGA</th>
                  <th className="col-title">Address</th>
                  <td>SLA</td>
                  <th className="col-title">Details</th>
                  <th className="col-action">Action</th>
                </tr>
              </thead>
              <tbody>
                {cases?.map((opt, index) => {
                  const cc = Constants.getSlaTimeLeft(opt.case?.slaExpire,holidays);
                  return (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${Constants.getItemById(frequentData?.casecategories, opt.case?.caseCategoryId)?.colour}`,
                        }}
                      >
                        {opt.case?.caseNumber}
                      </td>
                      <td>{opt.case?.caseTitle}</td>
                      <td>
                        {
                          Constants.getItemById(
                            frequentData?.casetype,
                            opt.case?.caseTypeId,
                          )?.caseType1
                        }
                      </td>
                      <td>
                        {" "}
                        {
                          Constants.getItemById(
                            frequentData?.casecategories,
                            opt.case?.caseCategoryId,
                          )?.categoryTitle
                        }
                      </td>
                      <td>
                        {" "}
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        )}
                      </td>
                      <td>
                        {
                          Constants.getItemById(
                            frequentData?.casestatuses,
                            opt.case?.caseStatusId,
                          )?.description
                        }
                      </td>
                      <td>
                        {
                          Constants.getItemById(lgs, opt.case?.party?.lga)
                            ?.title
                        }
                      </td>
                      <td>{opt.party?.address1}</td>
                      <td>
                        {" "}
                        <DeadlineBadge dateString={opt.slaExpire} />{" "}
                      </td>
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onContinue(opt, index)}
                        >
                          View
                        </JisButton>
                      </td>
                      {tab == "warrants" && (
                        <td>
                          <JisCheckbox
                            onChange={(e) => onCheck(e, opt)}
                            value={selected.has(opt.id)}
                          />
                        </td>
                      )}
                      {tab == "pending" && (
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onClear(opt, index)}
                          >
                            Clear
                          </JisButton>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {cases?.length > 0 && (
            <Pagenated
              onChangePageSize={(k) => setPageSize(k)}
              size={pageSize}
              total={count}
              maxPage={20}
              onPick={onPagePick}
            />
          )}
        </div>
      )}

      <BackLoader open={loading} />

      {openCase && active != null && (
        <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}

      {openCheck && (
        // <JisDialogForm
        //   title=" Case Assignment"
        //   onClose={() => setOpenCheck(false)}
        // >
        <div className="service_sheriff_wrapper">
          <div className="service_sheriff_bg_image">
            <div className="service_sheriff_modal">
              <p className="header">Assign To Execution Sheriff</p>
              <form onSubmit={onSave}>
                <div style={{ display: "flex" }}>
                  <div style={{ flex: 3 }}>
                    <div>
                      <div className="select-group">
                        <label>Execution Sheriff:</label>
                        <select
                          value={assignTo}
                          onChange={(e) => setAssignTo(e.target.value)}
                          required
                        >
                          <option value="">Select execution sheriff</option>
                          {sheriffs?.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.suffix} {opt.firstName} {opt.lastName}
                            </option>
                          ))}
                        </select>
                        {/* <div className="content-box" style={{ maxHeight: 300 }}>
                          {sheriffs?.map((opt) => (
                            <div
                              key={opt.id}
                              onClick={() => setAssignTo(opt.id)}
                              className={`selected ${opt.id == assignTo ? "active" : ""}`}
                            >
                              {opt.suffix} {opt.firstName} {opt.lastName}
                            </div>
                          ))}
                          {sheriffs?.length == 0 && <JisEmptyList />}
                        </div> */}
                      </div>
                    </div>
                    <div
                      className="input-group"
                      style={{
                        marginBottom: 8,
                      }}
                    >
                      <label>
                        Comment <span className="required">*</span>{" "}
                      </label>
                      <div
                        className="input-wrapper"
                        style={{ height: 120, background: "white" }}
                      >
                        <textarea
                          placeholder=" Comment"
                          name="comment"
                          required={true}
                          value={option.comment}
                          onChange={onOptionChange}
                          style={{
                            resize: "none",
                            height: "100%",
                          }}
                        />
                      </div>
                    </div>
                    {err != "" && <div className="error">{err}</div>}
                    <div style={{ marginBottom: 8, marginTop: 8 }}>
                      <JisCheckbox
                        value={option.manualVerify}
                        label="Please confirm you have manually checked, non has filled Motion 'Stay of Execution' manually "
                        onChange={(e) =>
                          setOption({ ...option, manualVerify: e })
                        }
                      />
                    </div>
                    <button
                      type="button"
                      className="bulk_cancel_btn"
                      onClick={() => setOpenCheck(false)}
                    >
                      Cancel{" "}
                    </button>
                    <button className="bulk_assign_btn" type="submit">
                      Save{" "}
                    </button>{" "}
                  </div>
                  <div
                    style={{ flex: 1, maxHeight: 300 }}
                    // className="content-box"
                  >
                    <div>
                      Selected Cases to Assign (
                      {Object.values(selectedWrits).length})
                    </div>
                    {Object.values(selectedWrits)?.map((opt, index) => (
                      <div className="selected" key={index}>
                        <div>{opt.case?.caseNumber}</div>
                        <p style={{ fontSize: 12 }}>{opt.case?.caseTitle}</p>
                        <p style={{ fontSize: 12 }}>
                          Party: {opt.party?.firstName} {opt.party?.lastName}
                        </p>
                        {!opt.verified && (
                          <p
                            className="error"
                            style={{ display: "flex", gap: 5 }}
                          >
                            <div style={{ flex: 1 }}>
                              {" "}
                              Motion- Stay on Execution
                            </div>
                            <DynamicIcon
                              iname="x"
                              onClick={() => onRemoveWrit(opt)}
                            ></DynamicIcon>
                          </p>
                        )}
                        {opt.verified && (
                          <p className="success-box">
                            Confirmed. No Stay of Execution
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        // </JisDialogForm>
      )}
      {openOption && (
        // <JisDialogForm
        //   title="Clear Options"
        //   onClose={() => setOpenOption(false)}
        // >
        <div className="hos_clear_option_modal">
          <div className="hos_modal">
            <div className="modal_header">
              <p>Clear Options</p>
              <button onClick={() => setOpenOption(false)}>
                <X />
              </button>
            </div>

            <form className="content_wrapper" onSubmit={onSaveClear}>
              <div>
                {/* <div
                  style={{
                    marginBottom: 8,
                  }}
                >
                  {" "}
                  forwards to Head of process{" "}
                </div> */}
                {active.verified == null && (
                  <JisButton variant="outline" onClick={onVerifyStay}>
                    Click to verify Online 'Stay of Execution' motion
                  </JisButton>
                )}

                {active.verified == false && (
                  <p className="error" style={{ display: "flex", gap: 5 }}>
                    <div style={{ flex: 1 }}> Motion- Stay on Execution</div>
                  </p>
                )}
                {active.verified == true && (
                  <p className="success-box">Confirmed. No Stay of Execution</p>
                )}
                <div style={{ marginTop: 12 }}>
                  <JisCheckbox
                    value={option.manualVerify}
                    label="PLEASE CONFIRM THAT NO MOTION FOR STAY OF EXECUTION HAS BEEN FILED"
                    onChange={(e) => setOption({ ...option, manualVerify: e })}
                  />
                </div>

                <div className="input-group">
                  <label>
                    Comment <span className="required">*</span>{" "}
                  </label>
                  <div className="input-wrapper" style={{ height: 120 }}>
                    <textarea
                      placeholder=" Comment"
                      name="comment"
                      required={true}
                      value={option.comment}
                      onChange={onOptionChange}
                      style={{
                        resize: "none",
                        height: "100%",
                      }}
                    />
                  </div>
                </div>

                {err != "" && <div className="error">{err}</div>}

                <div className="groupbtn">
                  <JisButton type="submit">Save </JisButton>
                  <JisButton
                    type="button"
                    variant="outline"
                    onClick={() => setOpenOption(false)}
                  >
                    Cancel{" "}
                  </JisButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        // {/* </JisDialogForm> */}
      )}
    </div>
  );
}

export default PostDeputySheriff;
